// extracted by mini-css-extract-plugin
export default {"recos":"Q3-z","productCardOverride":"R3-z","rowHasBadge":"S3-z"};